export default __webpack_public_path__ + "static/media/send.541b44c8.svg";